import { ReactComponent as DeletePDFFooterImage } from '@/assets/images/organize/organize-delete.svg';
import { ReactComponent as RotatePDFFooterImage } from '@/assets/images/organize/organize-rotate.svg';
import { ReactComponent as OrganizePDFFooterImage } from '@/assets/images/organize/organize-universal.svg';
import ExceededConversionError from '@/errors/ExceededConversionError';
import ValidationError from '@/errors/ValidationError';
import { hasFreeOperations } from '@/utils/accessControl';
import { getFileExtension } from '@/utils/files';
import { getI18nInstance } from '@/utils/i18n';
import { formatBytes } from '@/utils/miscellaneous';

/**
 * Maximum file size allowed (in bytes).
 */
export const MAX_FILE_SIZE_BYTES = 15728640; // 15MB

/**
 * Sets maximum free compression number for a user per day.
 * Allowed values:
 *  - null or negative integer number: unlimited conversions
 *  - positive integer number: specific conversions limit
 */
export const MAX_FREE_COMPRESSION_PER_DAY = 1;

const ALLOWED_FILE_EXTENSIONS = ['pdf'];

export function validateInputFile(file: File) {
  const i18n = getI18nInstance();

  if (!hasFreeOperations('organize')) {
    throw new ExceededConversionError(
      i18n.translate('pdfextra_organize_tool.errors.max_free_conversions', {
        MAX_FREE_CONVERSION_PER_DAY: Number(MAX_FREE_COMPRESSION_PER_DAY).toString(),
      })
    );
  }

  if (file.size > MAX_FILE_SIZE_BYTES) {
    throw new ValidationError(
      i18n.translate('pdfextra_organize_tool.errors.file_too_large', {
        MAX_FILE_SIZE: formatBytes(MAX_FILE_SIZE_BYTES),
      })
    );
  }

  const extension = getFileExtension(file.type);

  if (!ALLOWED_FILE_EXTENSIONS.includes(extension)) {
    throw new ValidationError(
      i18n.translate('pdfextra_organize_tool.errors.not_supported_file_format', {
        allowedExtensions: ALLOWED_FILE_EXTENSIONS.join(', '),
      })
    );
  }
}

export const getOrganizeFooterImage = () => {
  let ToolImage: React.FC<React.SVGProps<SVGSVGElement>>;
  const rotateTool = window.location.pathname.includes('/rotate-pdf-pages');
  const deleteTool = window.location.pathname.includes('/delete-pdf-pages');

  switch (true) {
    case rotateTool: {
      ToolImage = RotatePDFFooterImage;
      break;
    }
    case deleteTool: {
      ToolImage = DeletePDFFooterImage;
      break;
    }
    default: {
      ToolImage = OrganizePDFFooterImage;
    }
  }

  return ToolImage;
};
